import { sensorTotalDataConstants } from "../../constants/client";

export const sensorTotalData = {
  totalData,
  totalDataSuccess,
  totalDataFailure,
};

function totalData(payload) {
  return { type: sensorTotalDataConstants.AVG_DATA_REQUEST,  payload };
}

function totalDataSuccess(payload) {
  return { type: sensorTotalDataConstants.AVG_DATA_SUCCESS, payload };
}

function totalDataFailure(error) {
  return { type: sensorTotalDataConstants.AVG_DATA_FAILURE, error };
}